Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var require_logger = require('../utils/logger.cjs');
var require_global = require('../global.cjs');
var require_constant = require('../constant.cjs');
var require_share = require('../utils/share.cjs');
var require_manifest = require('../utils/manifest.cjs');
var require_load = require('../utils/load.cjs');
var require_context = require('../utils/context.cjs');
require('../utils/index.cjs');
var require_preload = require('../utils/preload.cjs');
var require_index$1 = require('../module/index.cjs');
var require_syncHook = require('../utils/hooks/syncHook.cjs');
var require_asyncHook = require('../utils/hooks/asyncHook.cjs');
var require_syncWaterfallHook = require('../utils/hooks/syncWaterfallHook.cjs');
var require_asyncWaterfallHooks = require('../utils/hooks/asyncWaterfallHooks.cjs');
var require_pluginSystem = require('../utils/hooks/pluginSystem.cjs');
require('../utils/hooks/index.cjs');
var require_SnapshotHandler = require('../plugins/snapshot/SnapshotHandler.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/remote/index.ts
var RemoteHandler = /*#__PURE__*/ function() {
    "use strict";
    function RemoteHandler(host) {
        _class_call_check._(this, RemoteHandler);
        this.hooks = new require_pluginSystem.PluginSystem({
            beforeRegisterRemote: new require_syncWaterfallHook.SyncWaterfallHook("beforeRegisterRemote"),
            registerRemote: new require_syncWaterfallHook.SyncWaterfallHook("registerRemote"),
            beforeRequest: new require_asyncWaterfallHooks.AsyncWaterfallHook("beforeRequest"),
            onLoad: new require_asyncHook.AsyncHook("onLoad"),
            handlePreloadModule: new require_syncHook.SyncHook("handlePreloadModule"),
            errorLoadRemote: new require_asyncHook.AsyncHook("errorLoadRemote"),
            beforePreloadRemote: new require_asyncHook.AsyncHook("beforePreloadRemote"),
            generatePreloadAssets: new require_asyncHook.AsyncHook("generatePreloadAssets"),
            afterPreloadRemote: new require_asyncHook.AsyncHook(),
            loadEntry: new require_asyncHook.AsyncHook()
        });
        this.host = host;
        this.idToRemoteMap = {};
    }
    _create_class._(RemoteHandler, [
        {
            key: "formatAndRegisterRemote",
            value: function formatAndRegisterRemote(globalOptions, userOptions) {
                return (userOptions.remotes || []).reduce((res, remote)=>{
                    this.registerRemote(remote, res, {
                        force: false
                    });
                    return res;
                }, globalOptions.remotes);
            }
        },
        {
            key: "setIdToRemoteMap",
            value: function setIdToRemoteMap(id, remoteMatchInfo) {
                var remote = remoteMatchInfo.remote, expose = remoteMatchInfo.expose;
                var name = remote.name, alias = remote.alias;
                this.idToRemoteMap[id] = {
                    name: remote.name,
                    expose
                };
                if (alias && id.startsWith(name)) {
                    var idWithAlias = id.replace(name, alias);
                    this.idToRemoteMap[idWithAlias] = {
                        name: remote.name,
                        expose
                    };
                    return;
                }
                if (alias && id.startsWith(alias)) {
                    var idWithName = id.replace(alias, name);
                    this.idToRemoteMap[idWithName] = {
                        name: remote.name,
                        expose
                    };
                }
            }
        },
        {
            key: "loadRemote",
            value: function loadRemote(id, options) {
                return _async_to_generator._(function*() {
                    var host = this.host;
                    try {
                        var _ref = options || {
                            loadFactory: true
                        }, _ref_loadFactory = _ref.loadFactory, loadFactory = _ref_loadFactory === void 0 ? true : _ref_loadFactory;
                        var _ref1 = yield this.getRemoteModuleAndOptions({
                            id
                        }), module = _ref1.module, moduleOptions = _ref1.moduleOptions, remoteMatchInfo = _ref1.remoteMatchInfo;
                        var pkgNameOrAlias = remoteMatchInfo.pkgNameOrAlias, remote = remoteMatchInfo.remote, expose = remoteMatchInfo.expose, idRes = remoteMatchInfo.id, remoteSnapshot = remoteMatchInfo.remoteSnapshot;
                        var moduleOrFactory = yield module.get(idRes, expose, options, remoteSnapshot);
                        var moduleWrapper = yield this.hooks.lifecycle.onLoad.emit({
                            id: idRes,
                            pkgNameOrAlias,
                            expose,
                            exposeModule: loadFactory ? moduleOrFactory : void 0,
                            exposeModuleFactory: loadFactory ? void 0 : moduleOrFactory,
                            remote,
                            options: moduleOptions,
                            moduleInstance: module,
                            origin: host
                        });
                        this.setIdToRemoteMap(id, remoteMatchInfo);
                        if (typeof moduleWrapper === "function") return moduleWrapper;
                        return moduleOrFactory;
                    } catch (error) {
                        var _ref2 = options || {
                            from: "runtime"
                        }, _ref_from = _ref2.from, from = _ref_from === void 0 ? "runtime" : _ref_from;
                        var failOver = yield this.hooks.lifecycle.errorLoadRemote.emit({
                            id,
                            error,
                            from,
                            lifecycle: "onLoad",
                            origin: host
                        });
                        if (!failOver) throw error;
                        return failOver;
                    }
                }).call(this);
            }
        },
        {
            key: "preloadRemote",
            value: function preloadRemote(preloadOptions) {
                return _async_to_generator._(function*() {
                    var host = this.host;
                    yield this.hooks.lifecycle.beforePreloadRemote.emit({
                        preloadOps: preloadOptions,
                        options: host.options,
                        origin: host
                    });
                    var preloadOps = require_preload.formatPreloadArgs(host.options.remotes, preloadOptions);
                    yield Promise.all(preloadOps.map((ops)=>_async_to_generator._(function*() {
                            var remote = ops.remote;
                            var remoteInfo = require_load.getRemoteInfo(remote);
                            var _ref = yield host.snapshotHandler.loadRemoteSnapshotInfo({
                                moduleInfo: remote
                            }), globalSnapshot = _ref.globalSnapshot, remoteSnapshot = _ref.remoteSnapshot;
                            var assets = yield this.hooks.lifecycle.generatePreloadAssets.emit({
                                origin: host,
                                preloadOptions: ops,
                                remote,
                                remoteInfo,
                                globalSnapshot,
                                remoteSnapshot
                            });
                            if (!assets) return;
                            require_preload.preloadAssets(remoteInfo, host, assets);
                        }).call(this)));
                }).call(this);
            }
        },
        {
            key: "registerRemotes",
            value: function registerRemotes(remotes, options) {
                var host = this.host;
                remotes.forEach((remote)=>{
                    this.registerRemote(remote, host.options.remotes, {
                        force: options === null || options === void 0 ? void 0 : options.force
                    });
                });
            }
        },
        {
            key: "getRemoteModuleAndOptions",
            value: function getRemoteModuleAndOptions(options) {
                return _async_to_generator._(function*() {
                    var host = this.host;
                    var id = options.id;
                    var loadRemoteArgs;
                    try {
                        loadRemoteArgs = yield this.hooks.lifecycle.beforeRequest.emit({
                            id,
                            options: host.options,
                            origin: host
                        });
                    } catch (error) {
                        loadRemoteArgs = yield this.hooks.lifecycle.errorLoadRemote.emit({
                            id,
                            options: host.options,
                            origin: host,
                            from: "runtime",
                            error,
                            lifecycle: "beforeRequest"
                        });
                        if (!loadRemoteArgs) throw error;
                    }
                    var idRes = loadRemoteArgs.id;
                    var remoteSplitInfo = require_manifest.matchRemoteWithNameAndExpose(host.options.remotes, idRes);
                    if (!remoteSplitInfo) require_logger.error(_module_federation_error_codes.RUNTIME_004, _module_federation_error_codes.runtimeDescMap, {
                        hostName: host.options.name,
                        requestId: idRes
                    }, void 0, require_context.optionsToMFContext(host.options));
                    var rawRemote = remoteSplitInfo.remote;
                    var remoteInfo = require_load.getRemoteInfo(rawRemote);
                    var matchInfo = yield host.sharedHandler.hooks.lifecycle.afterResolve.emit(_object_spread_props._(_object_spread._({
                        id: idRes
                    }, remoteSplitInfo), {
                        options: host.options,
                        origin: host,
                        remoteInfo
                    }));
                    var remote = matchInfo.remote, expose = matchInfo.expose;
                    require_logger.assert(remote && expose, `The 'beforeRequest' hook was executed, but it failed to return the correct 'remote' and 'expose' values while loading ${idRes}.`);
                    var module = host.moduleCache.get(remote.name);
                    var moduleOptions = {
                        host,
                        remoteInfo
                    };
                    if (!module) {
                        module = new require_index$1.Module(moduleOptions);
                        host.moduleCache.set(remote.name, module);
                    }
                    return {
                        module,
                        moduleOptions,
                        remoteMatchInfo: matchInfo
                    };
                }).call(this);
            }
        },
        {
            key: "registerRemote",
            value: function registerRemote(remote, targetRemotes, options) {
                var host = this.host;
                var normalizeRemote = ()=>{
                    if (remote.alias) {
                        var findEqual = targetRemotes.find((item)=>{
                            var _item_alias;
                            return remote.alias && (item.name.startsWith(remote.alias) || ((_item_alias = item.alias) === null || _item_alias === void 0 ? void 0 : _item_alias.startsWith(remote.alias)));
                        });
                        require_logger.assert(!findEqual, `The alias ${remote.alias} of remote ${remote.name} is not allowed to be the prefix of ${findEqual && findEqual.name} name or alias`);
                    }
                    if ("entry" in remote) {
                        if (_module_federation_sdk.isBrowserEnvValue && typeof window !== "undefined" && !remote.entry.startsWith("http")) remote.entry = new URL(remote.entry, window.location.origin).href;
                    }
                    if (!remote.shareScope) remote.shareScope = require_constant.DEFAULT_SCOPE;
                    if (!remote.type) remote.type = require_constant.DEFAULT_REMOTE_TYPE;
                };
                this.hooks.lifecycle.beforeRegisterRemote.emit({
                    remote,
                    origin: host
                });
                var registeredRemote = targetRemotes.find((item)=>item.name === remote.name);
                if (!registeredRemote) {
                    normalizeRemote();
                    targetRemotes.push(remote);
                    this.hooks.lifecycle.registerRemote.emit({
                        remote,
                        origin: host
                    });
                } else {
                    var messages = [
                        `The remote "${remote.name}" is already registered.`,
                        "Please note that overriding it may cause unexpected errors."
                    ];
                    if (options === null || options === void 0 ? void 0 : options.force) {
                        this.removeRemote(registeredRemote);
                        normalizeRemote();
                        targetRemotes.push(remote);
                        this.hooks.lifecycle.registerRemote.emit({
                            remote,
                            origin: host
                        });
                        (0, _module_federation_sdk.warn)(messages.join(" "));
                    }
                }
            }
        },
        {
            key: "removeRemote",
            value: function removeRemote(remote) {
                try {
                    var host = this.host;
                    var name = remote.name;
                    var remoteIndex = host.options.remotes.findIndex((item)=>item.name === name);
                    if (remoteIndex !== -1) host.options.remotes.splice(remoteIndex, 1);
                    var loadedModule = host.moduleCache.get(remote.name);
                    if (loadedModule) {
                        var _Object_getOwnPropertyDescriptor;
                        var remoteInfo = loadedModule.remoteInfo;
                        var key = remoteInfo.entryGlobalName;
                        if (require_global.CurrentGlobal[key]) if ((_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(require_global.CurrentGlobal, key)) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.configurable) delete require_global.CurrentGlobal[key];
                        else require_global.CurrentGlobal[key] = void 0;
                        var remoteEntryUniqueKey = require_load.getRemoteEntryUniqueKey(loadedModule.remoteInfo);
                        if (require_global.globalLoading[remoteEntryUniqueKey]) delete require_global.globalLoading[remoteEntryUniqueKey];
                        host.snapshotHandler.manifestCache.delete(remoteInfo.entry);
                        var remoteInsId = remoteInfo.buildVersion ? (0, _module_federation_sdk.composeKeyWithSeparator)(remoteInfo.name, remoteInfo.buildVersion) : remoteInfo.name;
                        var remoteInsIndex = require_global.CurrentGlobal.__FEDERATION__.__INSTANCES__.findIndex((ins)=>{
                            if (remoteInfo.buildVersion) return ins.options.id === remoteInsId;
                            else return ins.name === remoteInsId;
                        });
                        if (remoteInsIndex !== -1) {
                            var remoteIns = require_global.CurrentGlobal.__FEDERATION__.__INSTANCES__[remoteInsIndex];
                            remoteInsId = remoteIns.options.id || remoteInsId;
                            var globalShareScopeMap = require_share.getGlobalShareScope();
                            var isAllSharedNotUsed = true;
                            var needDeleteKeys = [];
                            Object.keys(globalShareScopeMap).forEach((instId)=>{
                                var shareScopeMap = globalShareScopeMap[instId];
                                shareScopeMap && Object.keys(shareScopeMap).forEach((shareScope)=>{
                                    var shareScopeVal = shareScopeMap[shareScope];
                                    shareScopeVal && Object.keys(shareScopeVal).forEach((shareName)=>{
                                        var sharedPkgs = shareScopeVal[shareName];
                                        sharedPkgs && Object.keys(sharedPkgs).forEach((shareVersion)=>{
                                            var shared = sharedPkgs[shareVersion];
                                            if (shared && typeof shared === "object" && shared.from === remoteInfo.name) if (shared.loaded || shared.loading) {
                                                shared.useIn = shared.useIn.filter((usedHostName)=>usedHostName !== remoteInfo.name);
                                                if (shared.useIn.length) isAllSharedNotUsed = false;
                                                else needDeleteKeys.push([
                                                    instId,
                                                    shareScope,
                                                    shareName,
                                                    shareVersion
                                                ]);
                                            } else needDeleteKeys.push([
                                                instId,
                                                shareScope,
                                                shareName,
                                                shareVersion
                                            ]);
                                        });
                                    });
                                });
                            });
                            if (isAllSharedNotUsed) {
                                remoteIns.shareScopeMap = {};
                                delete globalShareScopeMap[remoteInsId];
                            }
                            needDeleteKeys.forEach((param)=>{
                                var _param = _sliced_to_array._(param, 4), insId = _param[0], shareScope = _param[1], shareName = _param[2], shareVersion = _param[3];
                                var _globalShareScopeMap_insId_shareScope_shareName, _globalShareScopeMap_insId_shareScope, _globalShareScopeMap_insId;
                                (_globalShareScopeMap_insId = globalShareScopeMap[insId]) === null || _globalShareScopeMap_insId === void 0 ? true : (_globalShareScopeMap_insId_shareScope = _globalShareScopeMap_insId[shareScope]) === null || _globalShareScopeMap_insId_shareScope === void 0 ? true : (_globalShareScopeMap_insId_shareScope_shareName = _globalShareScopeMap_insId_shareScope[shareName]) === null || _globalShareScopeMap_insId_shareScope_shareName === void 0 ? true : delete _globalShareScopeMap_insId_shareScope_shareName[shareVersion];
                            });
                            require_global.CurrentGlobal.__FEDERATION__.__INSTANCES__.splice(remoteInsIndex, 1);
                        }
                        var hostGlobalSnapshot = require_SnapshotHandler.getGlobalRemoteInfo(remote, host).hostGlobalSnapshot;
                        if (hostGlobalSnapshot) {
                            var remoteKey = hostGlobalSnapshot && "remotesInfo" in hostGlobalSnapshot && hostGlobalSnapshot.remotesInfo && require_global.getInfoWithoutType(hostGlobalSnapshot.remotesInfo, remote.name).key;
                            if (remoteKey) {
                                delete hostGlobalSnapshot.remotesInfo[remoteKey];
                                if (Boolean(require_global.Global.__FEDERATION__.__MANIFEST_LOADING__[remoteKey])) delete require_global.Global.__FEDERATION__.__MANIFEST_LOADING__[remoteKey];
                            }
                        }
                        host.moduleCache.delete(remote.name);
                    }
                } catch (err) {
                    require_logger.logger.error(`removeRemote failed: ${err instanceof Error ? err.message : String(err)}`);
                }
            }
        }
    ]);
    return RemoteHandler;
}();
//#endregion
exports.RemoteHandler = RemoteHandler; //# sourceMappingURL=index.cjs.map
